import { h, Fragment, Component } from 'preact';
import { observer } from 'mobx-react';

import { Banner, withStore, withController } from '@searchspring/snap-preact-components';

import { Profile } from '../Profile/Profile';
import { ResultsComponent } from './ResultsComponent';
import { Toolbar } from '../Toolbar/Toolbar';

import './results.css';

@withStore
@withController
@observer
export class Results extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper');

    if (templateWrapper) {
      templateWrapper.classList.add('some-results');
    }
  }

  render() {
    const { merchandising, results } = this.props.store;
    const controller = this.props.controller;

    return (
      <div class='ss-results'>
        <Banner content={merchandising.content} type='header' />

        <Toolbar />

        <div class='clear'></div>

        <Profile name='results' controller={controller}>
          <ResultsComponent className='page-width' controller={controller} results={results} />
        </Profile>

        <div class='clear'></div>
      </div>
    );
  }
}

@withController
@withStore
@observer
export class NoResults extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper');

    if (templateWrapper) {
      templateWrapper.classList.add('no-results');
    }
  }

  render() {
    const store = this.props.store;
    // const dym = store.search.didYouMean

    return null;

    // If we eventually want to support suggestions here is how we would do that:
    // <div class="ss-no-results">
    //     <div class="ss-no-results-container">
    //         {dym && (
    //             <p class="ss-did-you-mean">
    //                 Did you mean <a href={dym.url.href}>{dym.string}</a>?
    //             </p>
    //         )}
    //     </div>
    // </div>
  }
}
